import { render, staticRenderFns } from "./UtilEquipTable.vue?vue&type=template&id=27b1b59c"
import script from "./UtilEquipTable.vue?vue&type=script&lang=js"
export * from "./UtilEquipTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports